/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Social_Export_PlatformInputs */

const cs_social_export_platform = /** @type {(inputs: Social_Export_PlatformInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platforma`)
};

const en_social_export_platform = /** @type {(inputs: Social_Export_PlatformInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platform`)
};

/**
* | output |
* | --- |
* | "Platform" |
*
* @param {Social_Export_PlatformInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const social_export_platform = /** @type {((inputs?: Social_Export_PlatformInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Social_Export_PlatformInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_social_export_platform(inputs)
	return cs_social_export_platform(inputs)
});